import { EditorContent } from '@tiptap/react';
import DOMPurify from 'dompurify';

import type { UseTiptapProps } from '@/types';

import { MenuBar } from '@/components/shared/menu-bar';
import { useTipTap } from '@/hooks/use-tiptap';
import { cn } from '@/lib/utils';

interface TipTapEditorProps extends UseTiptapProps {
  className?: string;
}

const TipTapEditor = ({ value, onChange, className }: TipTapEditorProps) => {
  const safeInitialValue = typeof value === 'string' ? DOMPurify.sanitize(value) : value;

  const handleEditorChange = (newHtml: string) => {
    if (onChange) {
      const safeHtml = DOMPurify.sanitize(newHtml);
      onChange(safeHtml);
    }
  };

  const editor = useTipTap({ value: safeInitialValue, onChange: handleEditorChange });

  return (
    <div
      className={cn(
        'flex flex-col w-full border rounded-md border-border bg-background overflow-hidden px-2',
        className
      )}
    >
      <MenuBar editor={editor} />
      <EditorContent
        editor={editor}
        className={cn(
          'flex-1 overflow-y-auto cursor-text min-h-[150px]',
          '[&_.is-editor-empty:first-child::before]:content-[attr(data-placeholder)]',
          '[&_.is-editor-empty:first-child::before]:text-muted-foreground',
          '[&_.is-editor-empty:first-child::before]:float-left',
          '[&_.is-editor-empty:first-child::before]:h-0',
          '[&_.is-editor-empty:first-child::before]:pointer-events-none break-word'
        )}
      />
    </div>
  );
};

export default TipTapEditor;
